import { render, staticRenderFns } from "./BaseIconBlock.vue?vue&type=template&id=6887c5d8&scoped=true&"
import script from "./BaseIconBlock.vue?vue&type=script&lang=js&"
export * from "./BaseIconBlock.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconBlock.vue?vue&type=style&index=0&id=6887c5d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887c5d8",
  null
  
)

export default component.exports